import React, {useRef} from 'react';
import HighchartsReact from 'highcharts-react-official';
import * as Highcharts from 'highcharts';
import {Box, Card, CardContent, Tooltip, IconButton} from '@mui/material';
import Info from '@mui/icons-material/Info';
import {COLORS, EXPORTING} from '@/utils/constants';
import {
    getExpectedIndicators,
    getIndicators
} from '@/containers/FdcMilanoCollaborationAgreements/Charts/VolunteersActivities/calculations';

interface IVolunteersActivitiesProps {
    collaborationAgreementSubmissions: any[],
    monitoringSubmissions: any[],
}

const VolunteersActivities = ({collaborationAgreementSubmissions, monitoringSubmissions}: IVolunteersActivitiesProps) => {
    const chartComponentRef = useRef<HighchartsReact.RefObject>(null);

    return (
        <Box>
            <Box>
                <Box className='section-title'>
                    <Box>
                        I. STATO DI AVANZAMENTO DEGLI ACCORDI DI COLLABORAZIONE
                    </Box>
                    <Tooltip
                        title={<>
                            Il visual mostra il confronto fra:
                            <li>il numero di accordi effettivamente stipulati con università, imprese e altri gruppi per
                                lo svolgimento di attività di volontariato e il corrispondente valore atteso;</li>
                            <li>il numero di volontari la cui attività è regolata da un accordo stipulato tra gli enti
                            che lo realizzano il suo ente di appartenenza (università/azienda) e il corrispondente
                                valore atteso</li>
                            <li>il numero di collaborazioni con servizi commerciali locali per l’erogazione di servizi
                                agli anziani e il corrispondente valore atteso</li>
                            I valori effettivi sono ottenuti a partire da “Scheda di rilevazione degli accordi di
                            collaborazione/convenzione” e “Scheda di Monitoraggio per la rilevazione del profilo dei
                            volontari”. I valori attesi fanno riferimento al documento riepilogativo KPI di progetto (5
                            convenzioni con università, imprese o altri gruppi per lo svolgimento di attività di
                            volontariato, 10 collaborazioni con servizi commerciali locali per l’erogazione di servizi
                            agli anziani)
                        </>}
                    >
                        <IconButton>
                            <Info fontSize='small'/>
                        </IconButton>
                    </Tooltip>
                </Box>
                <Card>
                    <CardContent>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={{
                                chart: {
                                    height: 400,
                                    type: 'column',
                                    style: {
                                        fontFamily: 'Rubik, sans-serif'
                                    },
                                    backgroundColor: '#fafafa'
                                },
                                title: {
                                    text: '',
                                },
                                xAxis: {
                                    categories: [
                                        'Numero di accordi stipulati con la finalità di reclutare volontari',
                                        'Numero di volontari la cui attività è regolata da un accordo stipulato tra gli enti che lo realizzano il suo ente di appartenenza (università/azienda)',
                                        'Numero di collaborazioni effettivamente avviate con servizi commerciali locali per l’erogazione di servizi agli anziani'
                                    ]
                                },
                                yAxis: {
                                    title: {
                                        text: ''
                                    }
                                },
                                series: [
                                    {
                                        color: COLORS.blue,
                                        name: 'Valore Effetivo',
                                        data: getIndicators(collaborationAgreementSubmissions, monitoringSubmissions)
                                    },
                                    {
                                        color: COLORS.red,
                                        name: 'Valore Atteso',
                                        data: getExpectedIndicators(collaborationAgreementSubmissions)
                                    },
                                ],
                                exporting: EXPORTING,
                            }}
                            ref={chartComponentRef}
                        />
                    </CardContent>
                </Card>
            </Box>
        </Box>
    )
}

export default VolunteersActivities;